import { useDiscoverStore } from '../../../zustand-stores';
import { defaultTimeRange } from '../../../zustand-stores/DiscoverStore/initialDiscoverStore';

const useCheckIfFiltersAreApplied = () => {
  return useDiscoverStore(store => {
    const { filters } = store;

    if (filters.dateLow) return true;
    if (filters.dateHigh) return true;
    if (filters.minimumMen) return true;
    if (filters.minimumWomen) return true;
    if (filters.minimumNonBinary) return true;
    if (filters.programTagIds.length) return true;
    if (filters.selectedGenders.length) return true;
    if (filters.selectedVenueIds.length) return true;
    if (filters.selectedDaysOfWeek.length) return true;
    if (filters.selectedSportNames.length) return true;
    if (filters.selectedSkillLevels.length) return true;
    if (filters.selectedProgramTypes.length) return true;
    if (filters.selectedNeighborhoodIds.length) return true;
    if (filters.timeLow !== defaultTimeRange.timeLow) return true;
    if (filters.timeHigh !== defaultTimeRange.timeHigh) return true;

    // Default case
    return false;
  });
};

export default useCheckIfFiltersAreApplied;
